import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { MatrizConstatacoesService } from "../../../../../services/matriz-constatacao.service";
import { ICancelarConstatacaoDto } from "../../../../../models/constatacao.model";
import { AuthService } from "../../../../../services/auth.service";

@Component({
  selector: 'app-modal-cancelar-constatacao',
  templateUrl: './modal-cancelar-matriz-constatacao.component.html',
  styleUrls: ['./modal-cancelar-matriz-constatacao.component.html']
})
export class ModalCancelarConstatacaoComponent implements OnInit {
  public form: FormGroup;
  public loading = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModalCancelarConstatacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matrizService: MatrizConstatacoesService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      justificativa: ['', [Validators.required, Validators.maxLength(500)]]
    });
  }

  public salvar(): void {
    if (!this.form.valid) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informe a justificativa para cancelar!",
      });
    }

    Swal.fire({
      title: 'Cancelar Constatação',
      text: 'Deseja realmente cancelar esta constatação?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, cancelar',
      cancelButtonText: 'Não'
    }).then(result => {
      if (result.value) {
        this.executarCancelamento();
      }
    });
  }

  private executarCancelamento(): void {
    this.loading = true;
    const dto: ICancelarConstatacaoDto = {
      constatacaoId: this.data.constatacaoId,
      justificativaCancelamento: this.form.value.justificativa,
      responsavelCancelamentoId: this.authService.usuario.id
    };

    this.matrizService.cancelarConstatacao(dto)
      .then(res => {
        if (res.sucesso) {
          Swal.fire('Sucesso', 'Constatação cancelada com sucesso', 'success');
          this.dialogRef.close(true);
        } else {
          Swal.fire('Erro', res.mensagem?.descricao || 'Erro ao cancelar constatação', 'error');
        }
      })
      .catch(err => {
        Swal.fire('Erro', err.mensagem?.descricao || 'Erro ao cancelar constatação', 'error');
      })
      .finally(() => this.loading = false);
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
